// extracted by mini-css-extract-plugin
module.exports = {"message":"FormMessage_message__3zBHW","error":"FormMessage_error__1x-Fw","success":"FormMessage_success__Bqxf3"};